import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { hasSession } from '../lib/auth-client.js'

export const Route = createFileRoute('/auth/callback')({
  component: AuthCallback,
})

function AuthCallback() {
  const navigate = useNavigate()

  useEffect(() => {
    // The Google OAuth round-trip set the session cookie on the API. Verify it
    // (cookie-based getSession), then route into the app or back to login.
    hasSession().then((ok) => {
      navigate({ to: ok ? '/dashboard' : '/login', replace: true })
    })
  }, [navigate])

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-muted">
      <div className="flex items-center gap-3 text-sm text-fg-muted">
        <span className="inline-block h-3 w-3 animate-spin rounded-full border border-current border-t-transparent" />
        Completing sign-in…
      </div>
    </div>
  )
}
